// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
body{margin-top:20px;}

.timeline {
    border-left: 3px solid #727cf5;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    background: rgba(114, 124, 245, 0.09);
    margin: 0 auto;
    letter-spacing: 0.2px;
    position: relative;
    line-height: 1.4em;
    font-size: 1.03em;
    padding: 50px;
    list-style: none;
    text-align: right;
    max-width: 40%;
}

@media (max-width: 767px) {
    .timeline {
        max-width: 98%;
        padding: 25px;
    }
}

.timeline h1 {
    font-weight: 300;
    font-size: 1.4em;
}

.timeline h2,
.timeline h3 {
    font-weight: 600;
    font-size: 1rem;
    margin-bottom: 10px;
}

.timeline .event {
    border-bottom: 1px dashed #e8ebf1;
    padding-bottom: 25px;
    margin-bottom: 25px;
    position: relative;
}

@media (max-width: 767px) {
    .timeline .event {
        padding-top: 30px;
    }
}

.timeline .event:last-of-type {
    padding-bottom: 0;
    margin-bottom: 0;
    border: none;
}

.timeline .event:before,
.timeline .event:after {
    position: absolute;
    display: block;
    top: 0;
}

.timeline .event:before {
    left: -257px;
    content: attr(data-date);
    text-align: right;
    font-weight: 100;
    font-size: 0.9em;
    min-width: 120px;
}

@media (max-width: 767px) {
    .timeline .event:before {
        left: 0px;
        text-align: left;
    }
}

.timeline .event:after {
    box-shadow: 0 0 0 3px #727cf5;
    left: -55.8px;
    background: #fff;
    border-radius: 50%;
    height: 9px;
    width: 9px;
    content: "";
    top: 5px;
}

@media (max-width: 767px) {
    .timeline .event:after {
        left: -31.8px;
    }
}

.rtl .timeline {
    border-left: 0;
    text-align: right;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
    border-right: 3px solid #727cf5;
}

.rtl .timeline .event::before {
    left: 0;
    right: -170px;
}

.rtl .timeline .event::after {
    left: 0;
    right: -55.8px;
}

.divScroll{
    height: 20rem;
    overflow:scroll;
}

.modal-backdrop{
    z-index: 999;
}

.modal{
    z-index: 1000;
}

.autocomplete-container {
    z-index: 1056; /* Asegúrate de que este valor sea mayor que el z-index del modal */
}

.btn-close{
    width: 2em;
}


.tooltip-container {
    position: relative;
    display: inline-block;
  }

  .tooltip-text {
    visibility: hidden;
    width: 120px;
    background-color: #000;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    top: 50%; /* Posiciona el tooltip encima del elemento */
    right: 100%;
    transform: translateY(-50%);
    opacity: 0;
    transition: opacity 0.3s;
  }

  .tooltip-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;;AAEpC;;AAEA;EACE;aACW;AACb;AACA,KAAK,eAAe,CAAC;;AAErB;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,4BAA4B;IAC5B,qCAAqC;IACrC,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,cAAc;QACd,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,MAAM;AACV;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,SAAS;QACT,gBAAgB;IACpB;AACJ;;AAEA;IAEI,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa,EAAE,mEAAmE;AACtF;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAE,6CAA6C;IACvD,WAAW;IACX,2BAA2B;IAC3B,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  \n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\nbody{margin-top:20px;}\n\n.timeline {\n    border-left: 3px solid #727cf5;\n    border-bottom-right-radius: 4px;\n    border-top-right-radius: 4px;\n    background: rgba(114, 124, 245, 0.09);\n    margin: 0 auto;\n    letter-spacing: 0.2px;\n    position: relative;\n    line-height: 1.4em;\n    font-size: 1.03em;\n    padding: 50px;\n    list-style: none;\n    text-align: right;\n    max-width: 40%;\n}\n\n@media (max-width: 767px) {\n    .timeline {\n        max-width: 98%;\n        padding: 25px;\n    }\n}\n\n.timeline h1 {\n    font-weight: 300;\n    font-size: 1.4em;\n}\n\n.timeline h2,\n.timeline h3 {\n    font-weight: 600;\n    font-size: 1rem;\n    margin-bottom: 10px;\n}\n\n.timeline .event {\n    border-bottom: 1px dashed #e8ebf1;\n    padding-bottom: 25px;\n    margin-bottom: 25px;\n    position: relative;\n}\n\n@media (max-width: 767px) {\n    .timeline .event {\n        padding-top: 30px;\n    }\n}\n\n.timeline .event:last-of-type {\n    padding-bottom: 0;\n    margin-bottom: 0;\n    border: none;\n}\n\n.timeline .event:before,\n.timeline .event:after {\n    position: absolute;\n    display: block;\n    top: 0;\n}\n\n.timeline .event:before {\n    left: -257px;\n    content: attr(data-date);\n    text-align: right;\n    font-weight: 100;\n    font-size: 0.9em;\n    min-width: 120px;\n}\n\n@media (max-width: 767px) {\n    .timeline .event:before {\n        left: 0px;\n        text-align: left;\n    }\n}\n\n.timeline .event:after {\n    -webkit-box-shadow: 0 0 0 3px #727cf5;\n    box-shadow: 0 0 0 3px #727cf5;\n    left: -55.8px;\n    background: #fff;\n    border-radius: 50%;\n    height: 9px;\n    width: 9px;\n    content: \"\";\n    top: 5px;\n}\n\n@media (max-width: 767px) {\n    .timeline .event:after {\n        left: -31.8px;\n    }\n}\n\n.rtl .timeline {\n    border-left: 0;\n    text-align: right;\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 4px;\n    border-top-left-radius: 4px;\n    border-right: 3px solid #727cf5;\n}\n\n.rtl .timeline .event::before {\n    left: 0;\n    right: -170px;\n}\n\n.rtl .timeline .event::after {\n    left: 0;\n    right: -55.8px;\n}\n\n.divScroll{\n    height: 20rem;\n    overflow:scroll;\n}\n\n.modal-backdrop{\n    z-index: 999;\n}\n\n.modal{\n    z-index: 1000;\n}\n\n.autocomplete-container {\n    z-index: 1056; /* Asegúrate de que este valor sea mayor que el z-index del modal */\n}\n\n.btn-close{\n    width: 2em;\n}\n\n\n.tooltip-container {\n    position: relative;\n    display: inline-block;\n  }\n\n  .tooltip-text {\n    visibility: hidden;\n    width: 120px;\n    background-color: #000;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px;\n    position: absolute;\n    z-index: 1;\n    top: 50%; /* Posiciona el tooltip encima del elemento */\n    right: 100%;\n    transform: translateY(-50%);\n    opacity: 0;\n    transition: opacity 0.3s;\n  }\n\n  .tooltip-container:hover .tooltip-text {\n    visibility: visible;\n    opacity: 1;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
